import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { parseReactProps } from '~/components/legacy/reactProps.js';

class AudioToolUpload extends Component {
  constructor(props) {
    super(props);
    const firstTool = (props.toolOptions || [])[0];
    const convertClean = props.convertClean || {};
    const outputFormats = convertClean.outputFormats || [{ key: 'mp3', label: 'MP3' }, { key: 'wav', label: 'WAV' }];
    const metadataModes = convertClean.metadataModes || [{ key: 'remove', label: 'Remove metadata' }, { key: 'keep', label: 'Keep metadata' }];
    const phoneSystemReady = props.phoneSystemReady || {};
    const phonePresets = phoneSystemReady.presets || [{ key: 'pcm_mono_wav', label: 'Standard announcement and hold music (compatible WAV)' }];
    const loudnessNormalizer = props.loudnessNormalizer || {};
    const loudnessPresets = loudnessNormalizer.presets || [{ key: 'podcast_speech', label: 'Podcast & speech' }];
    const voiceoverMusic = props.voiceoverMusic || {};
    const musicLevels = voiceoverMusic.levels || [
      { key: 'subtle', label: 'Voice-forward' },
      { key: 'normal', label: 'Balanced mix' },
      { key: 'strong', label: 'Music-forward' }
    ];
    const duckingLevels = voiceoverMusic.duckingLevels || [
      { key: 'light', label: 'Gentle' },
      { key: 'balanced', label: 'Balanced' },
      { key: 'strong', label: 'Pronounced' }
    ];
    const musicTracks = voiceoverMusic.tracks || [];
    const aiVoiceover = props.aiVoiceover || {};
    const aiVoiceSources = aiVoiceover.sources || [{ key: 'uploaded', label: 'Upload a voice recording' }];
    const aiVoiceLanguages = aiVoiceover.languages || [];
    const aiVoiceOptions = aiVoiceover.voices || [];
    const defaultAiVoiceSource = aiVoiceSources[0] ? aiVoiceSources[0].key : 'uploaded';
    const defaultAiVoiceLanguage = aiVoiceLanguages[0] ? aiVoiceLanguages[0].key : 'de';
    const defaultAiVoice = aiVoiceOptions.find((voice) => (voice.languages || []).includes(defaultAiVoiceLanguage)) || aiVoiceOptions[0];
    const watermarkedAudioPreview = props.watermarkedAudioPreview || {};
    const voiceGeneration = watermarkedAudioPreview.voiceGeneration || {};
    const languageOptions = voiceGeneration.languages || [];
    const voiceOptions = voiceGeneration.voices || [];
    const defaultVoiceLanguage = languageOptions[0] ? languageOptions[0].key : 'de';
    const defaultVoice = voiceOptions.find((voice) => (voice.languages || []).includes(defaultVoiceLanguage)) || voiceOptions[0];
    const previewDurations = watermarkedAudioPreview.previewDurations || [
      { key: 'full_track', label: 'Full track' },
      { key: '60', label: '60 seconds' },
      { key: '90', label: '90 seconds' },
      { key: '120', label: '120 seconds' }
    ];
    const watermarkPositions = watermarkedAudioPreview.watermarkPositions || [
      { key: 'beginning_end', label: 'Beginning and end' },
      { key: 'repeated', label: 'Repeated' }
    ];
    const watermarkLevels = watermarkedAudioPreview.watermarkLevels || [
      { key: 'subtle', label: 'Subtle' },
      { key: 'normal', label: 'Normal' },
      { key: 'strong', label: 'Strong' }
    ];
    const defaultPreviewDuration = previewDurations.find((option) => option.key === 'full_track') || previewDurations[0];
    const defaultWatermarkPosition = watermarkPositions.find((option) => option.key === 'repeated') || watermarkPositions[0];
    const defaultWatermarkLevel = watermarkLevels.find((option) => option.key === 'normal') || watermarkLevels[0];
    const defaultMusicLevel = musicLevels.find((option) => option.key === 'normal') || musicLevels[0];
    const defaultDuckingLevel = duckingLevels.find((option) => option.key === 'balanced') || duckingLevels[0];

    this.state = {
      toolKey: firstTool ? firstTool.key : '',
      outputFormat: outputFormats[0] ? outputFormats[0].key : 'mp3',
      metadataMode: metadataModes[0] ? metadataModes[0].key : 'remove',
      phonePreset: phonePresets[0] ? phonePresets[0].key : 'pcm_mono_wav',
      loudnessPreset: loudnessPresets[0] ? loudnessPresets[0].key : 'podcast_speech',
      musicLevel: defaultMusicLevel ? defaultMusicLevel.key : 'normal',
      duckingLevel: defaultDuckingLevel ? defaultDuckingLevel.key : 'balanced',
      sourceTrackId: musicTracks[0] ? String(musicTracks[0].source_track_id) : '',
      aiVoiceSource: defaultAiVoiceSource,
      aiVoiceText: '',
      aiVoiceLanguage: defaultAiVoiceLanguage,
      aiVoiceKey: defaultAiVoice ? defaultAiVoice.key : '',
      aiVoiceConsent: false,
      previewDuration: defaultPreviewDuration ? defaultPreviewDuration.key : 'full_track',
      watermarkPosition: defaultWatermarkPosition ? defaultWatermarkPosition.key : 'repeated',
      watermarkLevel: defaultWatermarkLevel ? defaultWatermarkLevel.key : 'normal',
      robustWatermark: false,
      recipientReference: '',
      watermarkVoiceSource: 'default',
      watermarkVoiceText: '',
      watermarkVoiceLanguage: defaultVoiceLanguage,
      watermarkVoiceKey: defaultVoice ? defaultVoice.key : '',
      watermarkVoiceFile: null,
      file: null,
      dragActive: false,
      status: 'idle',
      processingPhase: null,
      progress: 0,
      error: null,
      validationTarget: null,
      job: null,
      checkoutLoading: false
    };
    this.pollTimer = null;
    this.pollingJobId = null;
    this.pollFailureCount = 0;
    this.fileInputRef = React.createRef();
    this.uploadRequest = null;
    this.checkoutRequest = null;

    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleDragEnter = this.handleDragEnter.bind(this);
    this.handleDragOver = this.handleDragOver.bind(this);
    this.handleDragLeave = this.handleDragLeave.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
    this.handleToolChange = this.handleToolChange.bind(this);
    this.handleOutputFormatChange = this.handleOutputFormatChange.bind(this);
    this.handleMetadataModeChange = this.handleMetadataModeChange.bind(this);
    this.handlePhonePresetChange = this.handlePhonePresetChange.bind(this);
    this.handleLoudnessPresetChange = this.handleLoudnessPresetChange.bind(this);
    this.handleMusicLevelChange = this.handleMusicLevelChange.bind(this);
    this.handleDuckingLevelChange = this.handleDuckingLevelChange.bind(this);
    this.handleSourceTrackSelection = this.handleSourceTrackSelection.bind(this);
    this.handleAiVoiceSourceChange = this.handleAiVoiceSourceChange.bind(this);
    this.handleAiVoiceTextChange = this.handleAiVoiceTextChange.bind(this);
    this.handleAiVoiceLanguageChange = this.handleAiVoiceLanguageChange.bind(this);
    this.handleAiVoiceKeyChange = this.handleAiVoiceKeyChange.bind(this);
    this.handleAiVoiceConsentChange = this.handleAiVoiceConsentChange.bind(this);
    this.handlePreviewDurationChange = this.handlePreviewDurationChange.bind(this);
    this.handleWatermarkPositionChange = this.handleWatermarkPositionChange.bind(this);
    this.handleWatermarkLevelChange = this.handleWatermarkLevelChange.bind(this);
    this.handleRobustWatermarkChange = this.handleRobustWatermarkChange.bind(this);
    this.handleRecipientReferenceChange = this.handleRecipientReferenceChange.bind(this);
    this.handleWatermarkVoiceSourceChange = this.handleWatermarkVoiceSourceChange.bind(this);
    this.handleWatermarkVoiceTextChange = this.handleWatermarkVoiceTextChange.bind(this);
    this.handleWatermarkVoiceLanguageChange = this.handleWatermarkVoiceLanguageChange.bind(this);
    this.handleWatermarkVoiceKeyChange = this.handleWatermarkVoiceKeyChange.bind(this);
    this.handleWatermarkVoiceChange = this.handleWatermarkVoiceChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCheckout = this.handleCheckout.bind(this);
  }

  componentDidMount() {
    const returnedJobId = new URLSearchParams(window.location.search).get('audio_tool_job');
    if (!returnedJobId) return;

    this.pollingJobId = returnedJobId;
    this.pollFailureCount = 0;
    this.setState({ status: 'processing', processingPhase: 'queued', progress: 100, error: null });
    this.fetchStatus(returnedJobId);
  }

  handleFileChange(event) {
    const file = event.target.files && event.target.files[0] ? event.target.files[0] : null;
    this.selectFile(file);
  }

  handleDragEnter(event) {
    event.preventDefault();
    if (!this.isBusy()) this.setState({ dragActive: true });
  }

  handleDragOver(event) {
    event.preventDefault();
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
    if (!this.isBusy() && !this.state.dragActive) this.setState({ dragActive: true });
  }

  handleDragLeave(event) {
    event.preventDefault();
    if (event.currentTarget === event.target || !event.currentTarget.contains(event.relatedTarget)) {
      this.setState({ dragActive: false });
    }
  }

  handleDrop(event) {
    event.preventDefault();
    if (this.isBusy()) return;

    const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0] ? event.dataTransfer.files[0] : null;
    this.selectFile(file);
  }

  selectFile(file) {
    this.stopPolling();
    this.setState({ file, dragActive: false, status: 'idle', processingPhase: null, progress: 0, error: null, validationTarget: null, job: null, checkoutLoading: false });
  }

  handleToolChange(event) {
    this.resetForSelection({ toolKey: event.target.value, watermarkVoiceFile: null });
  }

  handleOutputFormatChange(event) {
    this.resetForSelection({ outputFormat: event.target.value });
  }

  handleMetadataModeChange(event) {
    this.resetForSelection({ metadataMode: event.target.value });
  }

  handlePhonePresetChange(event) {
    this.resetForSelection({ phonePreset: event.target.value });
  }

  handleLoudnessPresetChange(event) {
    this.resetForSelection({ loudnessPreset: event.target.value });
  }

  handleMusicLevelChange(event) {
    this.resetForSelection({ musicLevel: event.target.value });
  }

  handleDuckingLevelChange(event) {
    this.resetForSelection({ duckingLevel: event.target.value });
  }

  handleSourceTrackSelection(event) {
    this.resetForSelection({ sourceTrackId: String(event.currentTarget.dataset.sourceTrackId) });
  }

  handleAiVoiceSourceChange(event) {
    this.resetForSelection({ aiVoiceSource: event.target.value, file: null });
  }

  handleAiVoiceTextChange(event) {
    this.resetForSelection({ aiVoiceText: event.target.value });
  }

  handleAiVoiceLanguageChange(event) {
    const language = event.target.value;
    const voice = (this.aiVoiceoverOptions().voices || []).find((candidate) => (candidate.languages || []).includes(language));
    this.resetForSelection({ aiVoiceLanguage: language, aiVoiceKey: voice ? voice.key : '' });
  }

  handleAiVoiceKeyChange(event) {
    this.resetForSelection({ aiVoiceKey: event.target.value });
  }

  handleAiVoiceConsentChange(event) {
    this.resetForSelection({ aiVoiceConsent: event.target.checked });
  }

  handlePreviewDurationChange(event) {
    this.resetForSelection({ previewDuration: event.target.value });
  }

  handleWatermarkPositionChange(event) {
    this.resetForSelection({ watermarkPosition: event.target.value });
  }

  handleWatermarkLevelChange(event) {
    this.resetForSelection({ watermarkLevel: event.target.value });
  }

  handleRobustWatermarkChange(event) {
    this.resetForSelection({ robustWatermark: event.target.checked });
  }

  handleRecipientReferenceChange(event) {
    this.resetForSelection({ recipientReference: event.target.value });
  }

  handleWatermarkVoiceSourceChange(event) {
    this.resetForSelection({ watermarkVoiceSource: event.target.value, watermarkVoiceFile: null });
  }

  handleWatermarkVoiceTextChange(event) {
    this.resetForSelection({ watermarkVoiceText: event.target.value });
  }

  handleWatermarkVoiceLanguageChange(event) {
    const language = event.target.value;
    const voice = (this.watermarkedAudioPreviewOptions().voiceGeneration.voices || []).find((candidate) => (candidate.languages || []).includes(language));
    this.resetForSelection({ watermarkVoiceLanguage: language, watermarkVoiceKey: voice ? voice.key : '' });
  }

  handleWatermarkVoiceKeyChange(event) {
    this.resetForSelection({ watermarkVoiceKey: event.target.value });
  }

  handleWatermarkVoiceChange(event) {
    const file = event.target.files && event.target.files[0] ? event.target.files[0] : null;
    this.resetForSelection({ watermarkVoiceFile: file, watermarkVoiceSource: file ? 'custom' : 'default' });
  }

  handleSubmit(event) {
    event.preventDefault();

    const aiVoiceSource = this.aiVoiceSource();
    const aiVoiceGeneration = this.isAiVoiceover() && aiVoiceSource === 'elevenlabs';
    if (!this.state.file && !aiVoiceGeneration) {
      this.setError(this.copyValue('noFile', 'Please choose an audio file first.'), 'audio-tools-upload-file');
      return;
    }
    if (this.state.file && this.props.maxFileSizeBytes && this.state.file.size > this.props.maxFileSizeBytes) {
      this.setError(this.copyValue('fileSizeExceeded', 'The uploaded file is too large.'), 'audio-tools-upload-file');
      return;
    }
    if (aiVoiceGeneration) {
      const generation = this.aiVoiceoverOptions();
      if (!this.state.aiVoiceText.trim()) {
        this.setError(this.copyValue('aiVoiceTextRequired', 'Please enter the voiceover text.'), 'audio-tools-upload-ai-voice-text');
        return;
      }
      if (!this.state.aiVoiceKey || !this.state.aiVoiceLanguage || !generation.sources.some((source) => source.key === 'elevenlabs')) {
        this.setError(this.copyValue('aiVoiceUnavailable', 'The generated AI voice is not available.'), 'audio-tools-upload-ai-voice-key');
        return;
      }
      if (!this.state.aiVoiceConsent) {
        this.setError(this.copyValue('aiVoiceConsentRequired', 'Please confirm that you may submit this text and use the generated voice.'), 'audio-tools-upload-ai-voice-consent');
        return;
      }
    }
    const customVoice = this.watermarkedAudioPreviewOptions().customVoice;
    const voiceSource = this.watermarkVoiceSource();
    if (this.isWatermarkedAudioPreview() && this.state.watermarkVoiceFile && customVoice.maxFileSizeBytes && this.state.watermarkVoiceFile.size > customVoice.maxFileSizeBytes) {
      this.setError(this.copyValue('watermarkVoiceFileSizeExceeded', 'The watermark voice file is too large.'), 'audio-tools-upload-watermark-voice');
      return;
    }
    if (this.isWatermarkedAudioPreview() && voiceSource === 'elevenlabs') {
      const generation = this.watermarkedAudioPreviewOptions().voiceGeneration;
      if (!this.state.watermarkVoiceText.trim()) {
        this.setError(this.copyValue('watermarkVoiceTextRequired', 'Please enter the watermark text.'), 'audio-tools-upload-watermark-voice-text');
        return;
      }
      if (!this.state.watermarkVoiceKey || !this.state.watermarkVoiceLanguage || !generation.available) {
        this.setError(this.copyValue('watermarkVoiceUnavailable', 'The generated watermark voice is not available.'), 'audio-tools-upload-watermark-voice-key');
        return;
      }
    }
    if (this.isWatermarkedAudioPreview() && voiceSource === 'custom' && !this.state.watermarkVoiceFile) {
      this.setError(this.copyValue('watermarkVoiceRequired', 'Please choose a custom watermark voice.'), 'audio-tools-upload-watermark-voice');
      return;
    }
    if (this.isVoiceoverMusic() && !this.state.sourceTrackId) {
      this.setError(this.copyValue('musicTrackRequired', 'Please choose a music track.'), 'audio-tools-upload-music-track-heading');
      return;
    }

    this.stopPolling();
    this.setState({ status: 'uploading', progress: 0, error: null, job: null, checkoutLoading: false });
    this.upload(this.state.file);
  }

  componentWillUnmount() {
    this.stopPolling();
    this.abortUpload();
    this.abortCheckout();
  }

  upload(file) {
    this.abortUpload();
    const xhr = new XMLHttpRequest();
    this.uploadRequest = xhr;
    const formData = new FormData();

    formData.append('tool_key', this.state.toolKey);
    if (file) {
      formData.append('file', file, file.name);
    }
    if (this.state.toolKey === 'convert_clean') {
      formData.append('configuration[output_format]', this.state.outputFormat);
      formData.append('configuration[metadata]', this.state.metadataMode);
    }
    if (this.state.toolKey === 'phone_system_ready') {
      formData.append('configuration[preset]', this.state.phonePreset);
    }
    if (this.isLoudnessNormalizer()) {
      formData.append('configuration[preset]', this.state.loudnessPreset);
    }
    if (this.isVoiceoverMusic()) {
      formData.append('configuration[source_track_id]', this.state.sourceTrackId);
      formData.append('configuration[music_level]', this.state.musicLevel);
      formData.append('configuration[ducking_level]', this.state.duckingLevel);
    }
    if (this.isAiVoiceover()) {
      const voiceSource = this.aiVoiceSource();
      formData.append('configuration[voice_source]', voiceSource);
      if (voiceSource === 'elevenlabs') {
        formData.append('configuration[voice_text]', this.state.aiVoiceText.trim());
        formData.append('configuration[voice_language]', this.state.aiVoiceLanguage);
        formData.append('configuration[voice_key]', this.state.aiVoiceKey);
        formData.append('configuration[voice_consent]', this.state.aiVoiceConsent ? 'true' : 'false');
      }
    }
    if (this.isWatermarkedAudioPreview()) {
      formData.append('configuration[preview_duration]', this.state.previewDuration);
      formData.append('configuration[watermark_position]', this.state.watermarkPosition);
      formData.append('configuration[watermark_level]', this.state.watermarkLevel);
      if (this.state.robustWatermark) {
        formData.append('configuration[robust_watermark]', 'true');
      }
      if (this.state.recipientReference.trim()) {
        formData.append('configuration[recipient_reference]', this.state.recipientReference);
      }
      const voiceSource = this.watermarkVoiceSource();
      formData.append('configuration[watermark_voice_source]', voiceSource);
      if (voiceSource === 'elevenlabs') {
        formData.append('configuration[watermark_voice_text]', this.state.watermarkVoiceText.trim());
        formData.append('configuration[watermark_voice_language]', this.state.watermarkVoiceLanguage);
        formData.append('configuration[watermark_voice_key]', this.state.watermarkVoiceKey);
      }
      if (voiceSource === 'custom' && this.state.watermarkVoiceFile) {
        formData.append('watermark_voice', this.state.watermarkVoiceFile, this.state.watermarkVoiceFile.name);
      }
    }

    xhr.open('POST', this.props.uploadUrl, true);
    xhr.setRequestHeader('Accept', 'application/json');
    if (this.props.csrfToken) {
      xhr.setRequestHeader('X-CSRF-Token', this.props.csrfToken);
    }

    if (xhr.upload) {
      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
          this.setState({ progress: Math.round((event.loaded / event.total) * 100) });
        }
      });
    }

    xhr.addEventListener('load', () => {
      if (this.uploadRequest === xhr) this.uploadRequest = null;
      const payload = this.parseResponse(xhr);
      if (xhr.status >= 200 && xhr.status < 300) {
        const job = payload.job;
        if (job && job.publicId) {
          if (this.jobRequiresCheckout(job)) {
            this.stopPolling();
            this.setState({ status: 'checkout_required', processingPhase: null, progress: 100, error: null, job, checkoutLoading: false });
          } else {
            this.pollingJobId = job.publicId;
            this.pollFailureCount = 0;
            this.setState({ status: 'processing', processingPhase: this.processingPhaseFor(job), progress: 100, error: null, job, checkoutLoading: false });
            this.fetchStatus(job.publicId);
          }
        } else {
          this.setState({ status: 'success', processingPhase: null, progress: 100, error: null });
        }
        return;
      }

      const error = xhr.status === 413 ? this.copyValue('fileSizeExceeded', 'The uploaded file is too large.') : payload.message;
      this.setError(error || this.copyValue('genericError', 'The upload could not be completed.'));
    });
    xhr.addEventListener('error', () => {
      if (this.uploadRequest === xhr) this.uploadRequest = null;
      this.setError(this.copyValue('genericError', 'The upload could not be completed.'));
    });
    xhr.send(formData);
  }

  fetchStatus(publicId) {
    if (!publicId || this.pollingJobId !== publicId) return;

    const xhr = new XMLHttpRequest();
    const statusUrl = (this.props.statusUrlTemplate || '').replace('__PUBLIC_ID__', encodeURIComponent(publicId));
    xhr.open('GET', statusUrl, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.addEventListener('load', () => {
      if (this.pollingJobId !== publicId) return;

      const payload = this.parseResponse(xhr);
      if (xhr.status >= 200 && xhr.status < 300 && payload.job) {
        this.pollFailureCount = 0;
        const job = payload.job;
        if (job.status === 'completed') {
          this.stopPolling();
          this.setState({ status: 'success', processingPhase: null, progress: 100, error: null, job });
        } else if (this.jobRequiresCheckout(job)) {
          this.stopPolling();
          this.setState({ status: 'checkout_required', processingPhase: null, progress: 100, error: null, job, checkoutLoading: false });
        } else if (job.status === 'failed' || job.status === 'expired') {
          this.stopPolling();
          this.setState({ job });
          this.setError(job.errorMessage || this.copyValue('processingError', this.copyValue('genericError', 'The audio file could not be processed.')));
        } else {
          this.setState({ status: 'processing', processingPhase: this.processingPhaseFor(job), progress: 100, error: null, job });
          this.scheduleStatusPoll(publicId);
        }
        return;
      }

      this.retryStatusPoll(publicId);
    });
    xhr.addEventListener('error', () => {
      if (this.pollingJobId === publicId) this.retryStatusPoll(publicId);
    });
    xhr.send();
  }

  scheduleStatusPoll(publicId) {
    if (this.pollingJobId !== publicId) return;

    this.stopPollTimer();
    this.pollTimer = setTimeout(() => this.fetchStatus(publicId), this.props.statusPollIntervalMs || 1500);
  }

  retryStatusPoll(publicId) {
    if (this.pollingJobId !== publicId) return;

    this.pollFailureCount += 1;
    if (this.pollFailureCount > 3) {
      this.stopPolling();
      this.setError(this.copyValue('processingError', this.copyValue('genericError', 'The audio file could not be processed.')));
      return;
    }

    this.scheduleStatusPoll(publicId);
  }

  stopPollTimer() {
    if (this.pollTimer !== null) {
      clearTimeout(this.pollTimer);
      this.pollTimer = null;
    }
  }

  stopPolling() {
    this.stopPollTimer();
    this.pollingJobId = null;
    this.pollFailureCount = 0;
  }

  abortUpload() {
    if (this.uploadRequest && typeof this.uploadRequest.abort === 'function') {
      this.uploadRequest.abort();
    }
    this.uploadRequest = null;
  }

  handleCheckout() {
    const job = this.state.job;
    if (!job || !job.checkoutUrl || this.state.checkoutLoading) return;

    this.abortCheckout();
    const xhr = new XMLHttpRequest();
    this.checkoutRequest = xhr;
    this.setState({ checkoutLoading: true, error: null });
    xhr.open('POST', job.checkoutUrl, true);
    xhr.setRequestHeader('Accept', 'application/json');
    if (this.props.csrfToken) {
      xhr.setRequestHeader('X-CSRF-Token', this.props.csrfToken);
    }
    xhr.addEventListener('load', () => {
      if (this.checkoutRequest === xhr) this.checkoutRequest = null;
      const payload = this.parseResponse(xhr);
      if (xhr.status >= 200 && xhr.status < 300 && payload.url) {
        window.location.assign(payload.url);
        return;
      }

      this.setState({ checkoutLoading: false });
      this.setError(payload.message || this.copyValue('checkoutError', 'The payment could not be started. Please try again.'));
    });
    xhr.addEventListener('error', () => {
      if (this.checkoutRequest === xhr) this.checkoutRequest = null;
      this.setState({ checkoutLoading: false });
      this.setError(this.copyValue('checkoutError', 'The payment could not be started. Please try again.'));
    });
    xhr.send();
  }

  abortCheckout() {
    if (this.checkoutRequest && typeof this.checkoutRequest.abort === 'function') {
      this.checkoutRequest.abort();
    }
    this.checkoutRequest = null;
  }

  jobRequiresCheckout(job) {
    return Boolean(job && (job.checkoutRequired || job.status === 'checkout_required'));
  }

  processingPhaseFor(job) {
    return job && job.status === 'queued' ? 'queued' : 'processing';
  }

  copyValue(key, fallback) {
    return (this.props.copy && this.props.copy[key]) || fallback;
  }

  resetForSelection(update) {
    this.stopPolling();
    this.setState({ ...update, status: 'idle', processingPhase: null, progress: 0, error: null, validationTarget: null, job: null });
  }

  isBusy() {
    return this.state.status === 'uploading' || this.state.status === 'processing' || this.state.checkoutLoading;
  }

  formatFileSize(file) {
    if (!file || !Number.isFinite(file.size)) return '';
    if (file.size < 1024 * 1024) return `${Math.max(1, Math.round(file.size / 1024))} KB`;
    return `${(file.size / (1024 * 1024)).toFixed(1)} MB`;
  }

  formatTrackDuration(seconds) {
    const duration = Number(seconds);
    if (!Number.isFinite(duration) || duration <= 0) return '';

    const minutes = Math.floor(duration / 60);
    const remainingSeconds = Math.round(duration % 60).toString().padStart(2, '0');
    return `${minutes}:${remainingSeconds}`;
  }

  setError(error, validationTarget = null) {
    this.setState({ status: 'error', processingPhase: null, error, validationTarget }, () => {
      const target = validationTarget && typeof document !== 'undefined' ? document.getElementById(validationTarget) : null;
      if (target && typeof target.focus === 'function') {
        const disclosure = target.closest('details');
        if (disclosure) disclosure.open = true;
        target.focus();
      } else if (typeof document !== 'undefined') {
        const errorPanel = document.getElementById('audio-tools-upload-error');
        if (errorPanel && typeof errorPanel.focus === 'function') errorPanel.focus();
      }
    });
  }

  convertCleanOptions() {
    const options = this.props.convertClean || {};
    return {
      outputFormats: options.outputFormats || [{ key: 'mp3', label: 'MP3' }, { key: 'wav', label: 'WAV' }],
      metadataModes: options.metadataModes || [{ key: 'remove', label: 'Remove metadata' }, { key: 'keep', label: 'Keep metadata' }]
    };
  }

  isConvertClean() {
    return this.state.toolKey === 'convert_clean';
  }

  isPhoneSystemReady() {
    return this.state.toolKey === 'phone_system_ready';
  }

  isLoudnessNormalizer() {
    return this.state.toolKey === 'loudness_normalizer';
  }

  isAudioQc() {
    return this.state.toolKey === 'audio_qc';
  }

  isPodcastReady() {
    return this.state.toolKey === 'podcast_ready';
  }

  isVoiceoverMusic() {
    return this.state.toolKey === 'voiceover_music' || this.state.toolKey === 'ai_voiceover';
  }

  isAiVoiceover() {
    return this.state.toolKey === 'ai_voiceover';
  }

  isWatermarkedAudioPreview() {
    return this.state.toolKey === 'client_preview';
  }

  phoneSystemReadyOptions() {
    const options = this.props.phoneSystemReady || {};
    return options.presets || [{ key: 'pcm_mono_wav', label: 'Standard announcement and hold music (compatible WAV)' }];
  }

  loudnessNormalizerOptions() {
    const options = this.props.loudnessNormalizer || {};
    return options.presets || [{ key: 'podcast_speech', label: 'Podcast & speech' }];
  }

  voiceoverMusicOptions() {
    const options = this.props.voiceoverMusic || {};
    return {
      levels: options.levels || [
        { key: 'subtle', label: 'Voice-forward' },
        { key: 'normal', label: 'Balanced mix' },
        { key: 'strong', label: 'Music-forward' }
      ],
      duckingLevels: options.duckingLevels || [
        { key: 'light', label: 'Gentle' },
        { key: 'balanced', label: 'Balanced' },
        { key: 'strong', label: 'Pronounced' }
      ],
      tracks: options.tracks || []
    };
  }

  aiVoiceoverOptions() {
    const options = this.props.aiVoiceover || {};
    return {
      sources: options.sources || [{ key: 'uploaded', label: 'Upload a voice recording' }],
      languages: options.languages || [],
      voices: options.voices || [],
      maxTextLength: options.maxTextLength || 5000,
      provider: options.provider || 'ElevenLabs',
      disclosure: options.disclosure || 'Your text is sent to ElevenLabs for synthetic voice generation.',
      consentLabel: options.consentLabel || 'I may submit this text and use the generated voice.',
      consentHint: options.consentHint || 'Review the intended use and the provider terms before submitting.'
    };
  }

  aiVoiceSource() {
    const sources = this.aiVoiceoverOptions().sources;
    return sources.some((source) => source.key === this.state.aiVoiceSource) ? this.state.aiVoiceSource : 'uploaded';
  }

  watermarkedAudioPreviewOptions() {
    const options = this.props.watermarkedAudioPreview || {};
    return {
      previewDurations: options.previewDurations || [
        { key: 'full_track', label: 'Full track' },
        { key: '60', label: '60 seconds' },
        { key: '90', label: '90 seconds' },
        { key: '120', label: '120 seconds' }
      ],
      watermarkPositions: options.watermarkPositions || [
        { key: 'beginning_end', label: 'Beginning and end' },
        { key: 'repeated', label: 'Repeated' }
      ],
      watermarkLevels: options.watermarkLevels || [
        { key: 'subtle', label: 'Subtle' },
        { key: 'normal', label: 'Normal' },
        { key: 'strong', label: 'Strong' }
      ],
      forensicWatermark: options.forensicWatermark || { available: false },
      recipientMaxLength: options.recipientMaxLength || 200,
      recipientHint: options.recipientHint || 'Optional for your internal preview reference. This value is not written into the audio file.',
      voiceGeneration: options.voiceGeneration || { available: false, sources: [], languages: [], voices: [] },
      customVoice: options.customVoice || {}
    };
  }

  watermarkVoiceSource() {
    const options = this.watermarkedAudioPreviewOptions().voiceGeneration;
    if (options.sources && options.sources.length > 0) return this.state.watermarkVoiceSource;
    return this.state.watermarkVoiceFile ? 'custom' : 'default';
  }

  outputMetadataRows(metadata) {
    if (!metadata || typeof metadata !== 'object') return [];

    const numberWithUnit = (value, unit, digits = 2) => {
      const number = Number(value);
      return Number.isFinite(number) ? `${number.toFixed(digits)} ${unit}` : value;
    };
    if (metadata.report_type === 'audio_qc') {
      const checks = metadata.checks && typeof metadata.checks === 'object' ? metadata.checks : {};
      const statusLabel = (status) => {
        if (status === 'ok') return this.copyValue('audioQcOk', 'No attention needed');
        if (status === 'attention') return this.copyValue('audioQcAttention', 'Needs attention');
        if (status === 'measured') return this.copyValue('audioQcMeasured', 'Measured');
        return this.copyValue('audioQcUnknown', 'Not available');
      };
      const checkLabel = (check) => statusLabel(check && check.status);
      const clipping = checks.clipping || {};
      const loudness = checks.loudness || {};
      const channels = checks.channels || {};
      const codec = checks.codec || {};
      const sampleRate = checks.sample_rate || {};
      const longSilence = checks.long_silence || {};
      const metadataCheck = checks.metadata || {};
      const loudnessValues = [
        loudness.integrated_lufs === undefined ? null : numberWithUnit(loudness.integrated_lufs, 'LUFS'),
        loudness.true_peak_dbfs === undefined ? null : numberWithUnit(loudness.true_peak_dbfs, 'dBFS')
      ].filter((value) => value !== null && value !== undefined && value !== '');
      const longSilenceValue = Number(longSilence.count) > 0
        ? `${longSilence.count} (${numberWithUnit(longSilence.max_duration_seconds, 's', 3)})`
        : checkLabel(longSilence);
      const metadataValue = Number(metadataCheck.field_count) > 0
        ? this.copyValue('audioQcMetadataFields', '%{count} fields detected').replace('%{count}', metadataCheck.field_count)
        : this.copyValue('audioQcNoMetadata', 'No metadata detected');

      return [
        [this.copyValue('audioQcStatusLabel', 'Overall status'), statusLabel(metadata.status)],
        [this.copyValue('audioQcClippingLabel', 'Clipping'), `${checkLabel(clipping)}${clipping.clipped_samples === undefined ? '' : ` (${clipping.clipped_samples})`}`],
        [this.copyValue('audioQcLoudnessLabel', 'Loudness'), loudnessValues.length > 0 ? loudnessValues.join(' / ') : checkLabel(loudness)],
        [this.copyValue('audioQcChannelsLabel', 'Channels'), channels.count === undefined ? checkLabel(channels) : `${channels.count}${channels.layout ? ` (${channels.layout})` : ''}`],
        [this.copyValue('audioQcCodecLabel', 'Codec'), codec.name || checkLabel(codec)],
        [this.copyValue('audioQcSampleRateLabel', 'Sample rate'), sampleRate.hz === undefined ? checkLabel(sampleRate) : `${sampleRate.hz} Hz`],
        [this.copyValue('audioQcLongSilenceLabel', 'Long silence'), longSilenceValue],
        [this.copyValue('audioQcMetadataLabel', 'Metadata'), metadataValue],
        [this.copyValue('outputDurationLabel', 'Duration'), metadata.duration_seconds === undefined ? null : numberWithUnit(metadata.duration_seconds, 's', 3)],
        [this.copyValue('outputFormatMetadataLabel', 'Format'), metadata.format]
      ].filter((row) => row[1] !== undefined && row[1] !== null && row[1] !== '');
    }
    const normalizationRows = metadata.report_type === 'loudness_normalizer' ? [
      [this.copyValue('outputPresetLabel', 'Preset'), metadata.preset],
      [this.copyValue('outputTargetLufsLabel', 'Target loudness'), metadata.target_integrated_lufs === undefined ? null : numberWithUnit(metadata.target_integrated_lufs, 'LUFS')],
      [this.copyValue('outputTargetTruePeakLabel', 'Target true peak'), metadata.target_true_peak_dbtp === undefined ? null : numberWithUnit(metadata.target_true_peak_dbtp, 'dBTP')]
    ].filter((row) => row[1] !== null && row[1] !== undefined && row[1] !== '') : [];
    const podcastReadyRows = metadata.report_type === 'podcast_ready' ? [
      [this.copyValue('podcastReadyTargetLufsLabel', 'Target loudness'), metadata.target_integrated_lufs === undefined ? null : numberWithUnit(metadata.target_integrated_lufs, 'LUFS')],
      [this.copyValue('podcastReadyTargetTruePeakLabel', 'Target true peak'), metadata.target_true_peak_dbtp === undefined ? null : numberWithUnit(metadata.target_true_peak_dbtp, 'dBTP')]
    ].filter((row) => row[1] !== null && row[1] !== undefined && row[1] !== '') : [];
    const reportRows = [
      ...normalizationRows,
      ...podcastReadyRows,
      [this.copyValue('outputIntegratedLufsLabel', 'Integrated loudness'), metadata.integrated_lufs === undefined ? null : numberWithUnit(metadata.integrated_lufs, 'LUFS')],
      [this.copyValue('outputLoudnessRangeLabel', 'Loudness range'), metadata.loudness_range_lu === undefined ? null : numberWithUnit(metadata.loudness_range_lu, 'LU')],
      [this.copyValue('outputPeakDbfsLabel', 'Peak'), metadata.peak_dbfs === undefined ? null : numberWithUnit(metadata.peak_dbfs, 'dBFS')],
      [this.copyValue('outputTruePeakDbfsLabel', 'True peak'), metadata.true_peak_dbfs === undefined ? null : numberWithUnit(metadata.true_peak_dbfs, 'dBFS')]
    ].filter((row) => row[1] !== null && row[1] !== undefined && row[1] !== '');
    if (reportRows.length > 0) {
      reportRows.push(
        [this.copyValue('outputDurationLabel', 'Duration'), metadata.duration_seconds === undefined ? null : numberWithUnit(metadata.duration_seconds, 's', 3)],
        [this.copyValue('outputFormatMetadataLabel', 'Format'), metadata.format]
      );
      return reportRows.filter((row) => row[1] !== undefined && row[1] !== null && row[1] !== '');
    }

    const rows = [
      [this.copyValue('outputFormatMetadataLabel', 'Format'), metadata.format],
      [this.copyValue('outputCodecMetadataLabel', 'Codec'), metadata.codec],
      [this.copyValue('outputSampleRateMetadataLabel', 'Sample rate'), metadata.sample_rate ? `${metadata.sample_rate} Hz` : null],
      [this.copyValue('outputChannelsMetadataLabel', 'Channels'), metadata.channels],
      [this.copyValue('outputBitsPerSampleMetadataLabel', 'Bit depth'), metadata.bits_per_sample ? `${metadata.bits_per_sample}-bit` : null]
    ];
    return rows.filter((row) => row[1] !== undefined && row[1] !== null && row[1] !== '');
  }

  parseResponse(xhr) {
    if (xhr.response && typeof xhr.response === 'object') {
      return xhr.response;
    }

    try {
      return JSON.parse(xhr.responseText || '{}');
    } catch (error) {
      return {};
    }
  }

  render() {
    const copy = this.props.copy || {};
    const { toolOptions, acceptedFormats } = this.props;
    const uploading = this.state.status === 'uploading';
    const processing = this.state.status === 'processing';
    const processingCopy = this.state.processingPhase === 'queued'
      ? this.copyValue('queued', 'Waiting for processing …')
      : this.copyValue('processing', 'Processing audio file …');
    const checkoutRequired = this.state.status === 'checkout_required';
    const busy = uploading || processing || this.state.checkoutLoading;
    const accepted = (acceptedFormats || []).join(',');
    const convertClean = this.convertCleanOptions();
    const phoneSystemReady = this.phoneSystemReadyOptions();
    const loudnessNormalizer = this.loudnessNormalizerOptions();
    const voiceoverMusic = this.voiceoverMusicOptions();
    const aiVoiceover = this.aiVoiceoverOptions();
    const watermarkedAudioPreview = this.watermarkedAudioPreviewOptions();
    const outputFormatLabel = this.copyValue('outputFormatLabel', 'Output format');
    const metadataLabel = this.copyValue('metadataLabel', 'Metadata');
    const phoneSystemPresetLabel = this.copyValue('phoneSystemPresetLabel', 'Phone system format');
    const loudnessPresetLabel = this.copyValue('loudnessPresetLabel', 'Intended use');
    const configurationLabel = this.copyValue('configurationLabel', 'Set the output');
    const advancedOptionsLabel = this.copyValue('advancedOptionsLabel', 'Advanced settings');
    const advancedOptionsHint = this.copyValue('advancedOptionsHint', 'Optional: open this only when you want more control over the result.');
    const mixOptionsLabel = this.copyValue('mixOptionsLabel', advancedOptionsLabel);
    const watermarkOptionsLabel = this.copyValue('watermarkOptionsLabel', advancedOptionsLabel);
    const aiVoiceOptionsLabel = this.copyValue('aiVoiceOptionsLabel', advancedOptionsLabel);
    const musicTrackLabel = this.copyValue('musicTrackLabel', 'Music track');
    const musicLevelLabel = this.copyValue('musicLevelLabel', 'Music level');
    const duckingLevelLabel = this.copyValue('duckingLevelLabel', 'Automatic ducking');
    const aiVoiceSourceLabel = this.copyValue('aiVoiceSourceLabel', 'Voice source');
    const aiVoiceTextLabel = this.copyValue('aiVoiceTextLabel', 'Voiceover text');
    const aiVoiceLanguageLabel = this.copyValue('aiVoiceLanguageLabel', 'Voice language');
    const aiVoiceKeyLabel = this.copyValue('aiVoiceKeyLabel', 'Voice');
    const aiVoiceConsentLabel = this.copyValue('aiVoiceConsentLabel', aiVoiceover.consentLabel);
    const previewDurationLabel = this.copyValue('previewDurationLabel', 'Preview length');
    const watermarkPositionLabel = this.copyValue('watermarkPositionLabel', 'Watermark position');
    const watermarkLevelLabel = this.copyValue('watermarkLevelLabel', 'Watermark level');
    const forensicWatermarkLabel = this.copyValue('forensicWatermarkLabel', 'Robust watermarking');
    const forensicWatermarkHint = this.copyValue('forensicWatermarkHint', 'Optional internal identification layer; not a guarantee against removal.');
    const recipientReferenceLabel = this.copyValue('recipientReferenceLabel', 'Recipient (optional)');
    const watermarkVoiceSourceLabel = this.copyValue('watermarkVoiceSourceLabel', 'Watermark voice');
    const watermarkVoiceTextLabel = this.copyValue('watermarkVoiceTextLabel', 'Watermark text');
    const watermarkVoiceLanguageLabel = this.copyValue('watermarkVoiceLanguageLabel', 'Watermark language');
    const watermarkVoiceKeyLabel = this.copyValue('watermarkVoiceKeyLabel', 'Voice');
    const watermarkVoiceLabel = this.copyValue('watermarkVoiceLabel', 'Custom watermark voice (optional)');
    const customVoice = watermarkedAudioPreview.customVoice || {};
    const watermarkVoiceAcceptedFormats = customVoice.acceptedFormats && customVoice.acceptedFormats.length > 0 ? customVoice.acceptedFormats : (acceptedFormats || []);
    const voiceGeneration = watermarkedAudioPreview.voiceGeneration || {};
    const voiceSourceOptions = voiceGeneration.sources || [];
    const watermarkVoiceSource = this.watermarkVoiceSource();
    const generatedVoiceOptions = (voiceGeneration.voices || []).filter((voice) => (voice.languages || []).includes(this.state.watermarkVoiceLanguage));
    const aiVoiceSource = this.aiVoiceSource();
    const generatedAiVoiceOptions = (aiVoiceover.voices || []).filter((voice) => (voice.languages || []).includes(this.state.aiVoiceLanguage));

    return (
      <form className='audio-tools-upload' onSubmit={this.handleSubmit} noValidate>
        <div className='panel panel--shadow'>
          <div className='panel__head'>
            <h2 className='text-like-h3'>{copy.uploadPanelHeading || 'Prepare your file and result'}</h2>
            <p className='margin-bottom0'>{copy.uploadPanelHint || 'Choose a file and set up the output.'}</p>
          </div>
          <div className='panel__body'>
          <div className='grid grid--2-col grid--1-col-md-down grid--slim audio-tools-upload__fields'>
            {!this.props.hideToolSelector && (
              <div className='input select optional'>
                <label htmlFor='audio-tools-upload-tool'>{copy.toolLabel}</label>
                <select id='audio-tools-upload-tool' value={this.state.toolKey} onChange={this.handleToolChange} disabled={busy}>
                  {(toolOptions || []).map((tool) => <option key={tool.key} value={tool.key}>{tool.label}</option>)}
                </select>
              </div>
            )}
            <p className='audio-tools-upload__configuration-label text-size-small text-bold text-color-secondary'>{configurationLabel}</p>
            {this.isAiVoiceover() && (
              <div className='input select optional'>
                <label htmlFor='audio-tools-upload-ai-voice-source'>{aiVoiceSourceLabel}</label>
                <select id='audio-tools-upload-ai-voice-source' value={aiVoiceSource} onChange={this.handleAiVoiceSourceChange} disabled={busy}>
                  {aiVoiceover.sources.map((option) => <option key={option.key} value={option.key}>{option.label}</option>)}
                </select>
              </div>
            )}
            {(!this.isAiVoiceover() || aiVoiceSource === 'uploaded') && (
              <div
                className={`audio-tools-upload__dropzone${this.state.dragActive ? ' is-dragging' : ''}${busy ? ' is-disabled' : ''}`}
                onDragEnter={this.handleDragEnter}
                onDragOver={this.handleDragOver}
                onDragLeave={this.handleDragLeave}
                onDrop={this.handleDrop}
              >
                <div className='audio-tools-upload__dropzone-icon' aria-hidden='true'>↥</div>
                <p className='audio-tools-upload__dropzone-title'>{copy.dropzoneTitle || copy.fileLabel}</p>
                <p className='audio-tools-upload__dropzone-hint'>{copy.dropzoneHint || copy.allowedFormats}</p>
                <label className='audio-tools-upload__dropzone-action' htmlFor='audio-tools-upload-file'>
                  <span className='button button--ghost-secondary'>{copy.chooseFile || copy.fileLabel}</span>
                  <input id='audio-tools-upload-file' className='audio-tools-upload__native-input' ref={this.fileInputRef} type='file' accept={accepted} onChange={this.handleFileChange} disabled={busy} aria-describedby={this.state.validationTarget === 'audio-tools-upload-file' ? 'audio-tools-upload-formats audio-tools-upload-error' : 'audio-tools-upload-formats'} aria-errormessage={this.state.validationTarget === 'audio-tools-upload-file' ? 'audio-tools-upload-error' : undefined} aria-invalid={this.state.validationTarget === 'audio-tools-upload-file' ? 'true' : undefined} />
                </label>
                {this.state.file && (
                  <p className='audio-tools-upload__file-meta' aria-live='polite'>
                    <span>{copy.selectedFileLabel || copy.fileLabel}: </span>
                    <span className='audio-tools-upload__file-name'>{this.state.file.name}</span>
                    {this.formatFileSize(this.state.file) && <span> ({this.formatFileSize(this.state.file)})</span>}
                  </p>
                )}
                <p id='audio-tools-upload-formats' className='text-size-small text-color-secondary'>{copy.allowedFormats} {this.props.maxFileSizeBytes && copy.maxFileSize} {this.props.maxDurationSeconds && copy.maxDuration}</p>
              </div>
            )}
            {this.isAiVoiceover() && aiVoiceSource === 'elevenlabs' && (
              <section className='audio-tools-upload__advanced audio-tools-upload__configuration'>
                <h3 className='text-like-h4'>{aiVoiceOptionsLabel}</h3>
                <p className='text-size-small text-color-secondary'>{this.copyValue('aiVoiceOptionsHint', 'These details are required to generate the synthetic voice.')}</p>
                <div className='input select optional'>
                  <label htmlFor='audio-tools-upload-ai-voice-language'>{aiVoiceLanguageLabel}</label>
                  <select id='audio-tools-upload-ai-voice-language' value={this.state.aiVoiceLanguage} onChange={this.handleAiVoiceLanguageChange} disabled={busy}>
                    {aiVoiceover.languages.map((option) => <option key={option.key} value={option.key}>{option.label}</option>)}
                  </select>
                </div>
                <div className='input select optional'>
                  <label htmlFor='audio-tools-upload-ai-voice-key'>{aiVoiceKeyLabel}</label>
                  <select id='audio-tools-upload-ai-voice-key' value={this.state.aiVoiceKey} onChange={this.handleAiVoiceKeyChange} disabled={busy} aria-describedby={this.state.validationTarget === 'audio-tools-upload-ai-voice-key' ? 'audio-tools-upload-error' : undefined} aria-errormessage={this.state.validationTarget === 'audio-tools-upload-ai-voice-key' ? 'audio-tools-upload-error' : undefined} aria-invalid={this.state.validationTarget === 'audio-tools-upload-ai-voice-key' ? 'true' : undefined}>
                    {generatedAiVoiceOptions.map((option) => <option key={option.key} value={option.key}>{option.label}</option>)}
                  </select>
                </div>
                <div className='input text optional'>
                  <label htmlFor='audio-tools-upload-ai-voice-text'>{aiVoiceTextLabel}</label>
                  <textarea id='audio-tools-upload-ai-voice-text' value={this.state.aiVoiceText} onChange={this.handleAiVoiceTextChange} maxLength={aiVoiceover.maxTextLength} disabled={busy} aria-describedby={this.state.validationTarget === 'audio-tools-upload-ai-voice-text' ? 'audio-tools-upload-ai-voice-disclosure audio-tools-upload-error' : 'audio-tools-upload-ai-voice-disclosure'} aria-errormessage={this.state.validationTarget === 'audio-tools-upload-ai-voice-text' ? 'audio-tools-upload-error' : undefined} aria-invalid={this.state.validationTarget === 'audio-tools-upload-ai-voice-text' ? 'true' : undefined} />
                  <p id='audio-tools-upload-ai-voice-disclosure' className='text-size-small text-color-secondary'>{aiVoiceover.disclosure}</p>
                </div>
                <div className='input checkbox optional'>
                  <label htmlFor='audio-tools-upload-ai-voice-consent'>
                    <input id='audio-tools-upload-ai-voice-consent' type='checkbox' checked={this.state.aiVoiceConsent} onChange={this.handleAiVoiceConsentChange} disabled={busy} aria-describedby={this.state.validationTarget === 'audio-tools-upload-ai-voice-consent' ? 'audio-tools-upload-ai-voice-consent-hint audio-tools-upload-error' : 'audio-tools-upload-ai-voice-consent-hint'} aria-errormessage={this.state.validationTarget === 'audio-tools-upload-ai-voice-consent' ? 'audio-tools-upload-error' : undefined} aria-invalid={this.state.validationTarget === 'audio-tools-upload-ai-voice-consent' ? 'true' : undefined} />
                    {aiVoiceConsentLabel}
                  </label>
                  <p id='audio-tools-upload-ai-voice-consent-hint' className='text-size-small text-color-secondary'>{aiVoiceover.consentHint}</p>
                </div>
              </section>
            )}
            {this.isPhoneSystemReady() && (
              <div className='input select optional'>
                <label htmlFor='audio-tools-upload-phone-system-preset'>{phoneSystemPresetLabel}</label>
                <select id='audio-tools-upload-phone-system-preset' value={this.state.phonePreset} onChange={this.handlePhonePresetChange} disabled={busy}>
                  {phoneSystemReady.map((option) => <option key={option.key} value={option.key}>{option.label}</option>)}
                </select>
              </div>
            )}
            {this.isLoudnessNormalizer() && (
              <div className='input select optional'>
                <label htmlFor='audio-tools-upload-loudness-preset'>{loudnessPresetLabel}</label>
                <select id='audio-tools-upload-loudness-preset' value={this.state.loudnessPreset} onChange={this.handleLoudnessPresetChange} disabled={busy}>
                  {loudnessNormalizer.map((option) => <option key={option.key} value={option.key}>{option.label}</option>)}
                </select>
              </div>
            )}
            {this.isVoiceoverMusic() && (
              <>
                {voiceoverMusic.tracks.length > 0 && (
                  <div className='grid grid--2-col grid--1-col-md-down grid--slim audio-tools-upload__track-picker' role='group' aria-labelledby='audio-tools-upload-music-track-heading' aria-describedby={this.state.validationTarget === 'audio-tools-upload-music-track-heading' ? 'audio-tools-upload-error' : undefined}>
                    <h3 id='audio-tools-upload-music-track-heading' className='audio-tools-upload__track-picker-heading' tabIndex='-1'>{this.copyValue('trackSelectionLabel', musicTrackLabel)}</h3>
                    {voiceoverMusic.tracks.map((track) => {
                      const selected = String(track.source_track_id) === String(this.state.sourceTrackId);
                      const waveform = track.waveform && track.waveform.inactive;
                      return (
                        <article key={track.source_track_id} className={`audio-tools-upload__track-option${selected ? ' is-selected' : ''}`}>
                          <div>
                            <h4 className='text-like-h4 audio-tools-upload__track-title'>{track.title}</h4>
                            {this.formatTrackDuration(track.duration_seconds) && <p className='audio-tools-upload__track-meta'>{this.formatTrackDuration(track.duration_seconds)}</p>}
                          </div>
                          {track.preview_url ? (
                            <audio controls preload='none' aria-label={this.copyValue('trackPreviewLabel', 'Music preview for %{title}').replace('%{title}', track.title)}>
                              <source src={track.preview_url} type='audio/mpeg' />
                            </audio>
                          ) : <p className='audio-tools-upload__track-meta'>{this.copyValue('noTrackPreview', 'No preview is currently available for this track.')}</p>}
                          {waveform && <div className='audio-tools-upload__track-waveform' aria-hidden='true'><img src={waveform} alt='' /></div>}
                          <button type='button' className={`button ${selected ? 'button--secondary' : 'button--ghost-secondary'} audio-tools-upload__track-button`} data-source-track-id={track.source_track_id} onClick={this.handleSourceTrackSelection} disabled={busy} aria-pressed={selected} aria-label={`${selected ? this.copyValue('selectedTrack', 'Selected') : this.copyValue('selectTrack', 'Select this track')}: ${track.title}`}>
                            {selected ? this.copyValue('selectedTrack', 'Selected') : this.copyValue('selectTrack', 'Select this track')}
                          </button>
                        </article>
                      );
                    })}
                  </div>
                )}
                <details className='audio-tools-upload__advanced'>
                  <summary>{mixOptionsLabel}</summary>
                  <p className='text-size-small text-color-secondary'>{advancedOptionsHint}</p>
                  <div className='input select optional'>
                    <label htmlFor='audio-tools-upload-music-level'>{musicLevelLabel}</label>
                    <select id='audio-tools-upload-music-level' value={this.state.musicLevel} onChange={this.handleMusicLevelChange} disabled={busy}>
                      {voiceoverMusic.levels.map((option) => <option key={option.key} value={option.key}>{option.label}</option>)}
                    </select>
                  </div>
                  <div className='input select optional'>
                    <label htmlFor='audio-tools-upload-ducking-level'>{duckingLevelLabel}</label>
                    <select id='audio-tools-upload-ducking-level' value={this.state.duckingLevel} onChange={this.handleDuckingLevelChange} disabled={busy}>
                      {voiceoverMusic.duckingLevels.map((option) => <option key={option.key} value={option.key}>{option.label}</option>)}
                    </select>
                  </div>
                </details>
              </>
            )}
            {this.isConvertClean() && (
              <>
                <div className='input select optional'>
                  <label htmlFor='audio-tools-upload-output-format'>{outputFormatLabel}</label>
                  <select id='audio-tools-upload-output-format' value={this.state.outputFormat} onChange={this.handleOutputFormatChange} disabled={busy}>
                    {convertClean.outputFormats.map((option) => <option key={option.key} value={option.key}>{option.label}</option>)}
                  </select>
                </div>
                <div className='input select optional'>
                  <label htmlFor='audio-tools-upload-metadata'>{metadataLabel}</label>
                  <select id='audio-tools-upload-metadata' value={this.state.metadataMode} onChange={this.handleMetadataModeChange} disabled={busy}>
                    {convertClean.metadataModes.map((option) => <option key={option.key} value={option.key}>{option.label}</option>)}
                  </select>
                </div>
              </>
            )}
            {this.isWatermarkedAudioPreview() && (
              <>
                <div className='input select optional'>
                  <label htmlFor='audio-tools-upload-preview-duration'>{previewDurationLabel}</label>
                  <select id='audio-tools-upload-preview-duration' value={this.state.previewDuration} onChange={this.handlePreviewDurationChange} disabled={busy}>
                    {watermarkedAudioPreview.previewDurations.map((option) => <option key={option.key} value={option.key}>{option.label}</option>)}
                  </select>
                </div>
                <details className='audio-tools-upload__advanced'>
                  <summary>{watermarkOptionsLabel}</summary>
                  <p className='text-size-small text-color-secondary'>{advancedOptionsHint}</p>
                  <div className='input select optional'>
                    <label htmlFor='audio-tools-upload-watermark-position'>{watermarkPositionLabel}</label>
                    <select id='audio-tools-upload-watermark-position' value={this.state.watermarkPosition} onChange={this.handleWatermarkPositionChange} disabled={busy}>
                      {watermarkedAudioPreview.watermarkPositions.map((option) => <option key={option.key} value={option.key}>{option.label}</option>)}
                    </select>
                  </div>
                  <div className='input select optional'>
                    <label htmlFor='audio-tools-upload-watermark-level'>{watermarkLevelLabel}</label>
                    <select id='audio-tools-upload-watermark-level' value={this.state.watermarkLevel} onChange={this.handleWatermarkLevelChange} disabled={busy}>
                      {watermarkedAudioPreview.watermarkLevels.map((option) => <option key={option.key} value={option.key}>{option.label}</option>)}
                    </select>
                  </div>
                  {watermarkedAudioPreview.forensicWatermark.available && (
                    <div className='input checkbox optional'>
                      <label htmlFor='audio-tools-upload-forensic-watermark'>
                        <input id='audio-tools-upload-forensic-watermark' type='checkbox' checked={this.state.robustWatermark} onChange={this.handleRobustWatermarkChange} disabled={busy} aria-describedby='audio-tools-upload-forensic-watermark-hint' />
                        {forensicWatermarkLabel}
                      </label>
                      <p id='audio-tools-upload-forensic-watermark-hint' className='text-size-small text-color-secondary'>{watermarkedAudioPreview.forensicWatermark.hint || forensicWatermarkHint}</p>
                    </div>
                  )}
                  <div className='input string optional'>
                    <label htmlFor='audio-tools-upload-recipient-reference'>{recipientReferenceLabel}</label>
                    <input id='audio-tools-upload-recipient-reference' type='text' value={this.state.recipientReference} onChange={this.handleRecipientReferenceChange} maxLength={watermarkedAudioPreview.recipientMaxLength} placeholder={this.copyValue('recipientReferencePlaceholder', 'e.g. Example Agency')} disabled={busy} aria-describedby='audio-tools-upload-recipient-reference-hint' />
                    <p id='audio-tools-upload-recipient-reference-hint' className='text-size-small text-color-secondary'>{watermarkedAudioPreview.recipientHint}</p>
                  </div>
                  {voiceSourceOptions.length > 0 && (
                    <div className='input select optional'>
                      <label htmlFor='audio-tools-upload-watermark-voice-source'>{watermarkVoiceSourceLabel}</label>
                      <select id='audio-tools-upload-watermark-voice-source' value={watermarkVoiceSource} onChange={this.handleWatermarkVoiceSourceChange} disabled={busy}>
                        {voiceSourceOptions.map((option) => <option key={option.key} value={option.key}>{option.label}</option>)}
                      </select>
                    </div>
                  )}
                  {watermarkVoiceSource === 'elevenlabs' && (
                    <>
                      <div className='input select optional'>
                        <label htmlFor='audio-tools-upload-watermark-voice-language'>{watermarkVoiceLanguageLabel}</label>
                        <select id='audio-tools-upload-watermark-voice-language' value={this.state.watermarkVoiceLanguage} onChange={this.handleWatermarkVoiceLanguageChange} disabled={busy}>
                          {(voiceGeneration.languages || []).map((option) => <option key={option.key} value={option.key}>{option.label}</option>)}
                        </select>
                      </div>
                      <div className='input select optional'>
                        <label htmlFor='audio-tools-upload-watermark-voice-key'>{watermarkVoiceKeyLabel}</label>
                        <select id='audio-tools-upload-watermark-voice-key' value={this.state.watermarkVoiceKey} onChange={this.handleWatermarkVoiceKeyChange} disabled={busy} aria-describedby={this.state.validationTarget === 'audio-tools-upload-watermark-voice-key' ? 'audio-tools-upload-error' : undefined} aria-errormessage={this.state.validationTarget === 'audio-tools-upload-watermark-voice-key' ? 'audio-tools-upload-error' : undefined} aria-invalid={this.state.validationTarget === 'audio-tools-upload-watermark-voice-key' ? 'true' : undefined}>
                          {generatedVoiceOptions.map((option) => <option key={option.key} value={option.key}>{option.label}</option>)}
                        </select>
                      </div>
                      <div className='input text optional'>
                        <label htmlFor='audio-tools-upload-watermark-voice-text'>{watermarkVoiceTextLabel}</label>
                        <textarea id='audio-tools-upload-watermark-voice-text' value={this.state.watermarkVoiceText} onChange={this.handleWatermarkVoiceTextChange} maxLength={voiceGeneration.maxTextLength} disabled={busy} aria-describedby={this.state.validationTarget === 'audio-tools-upload-watermark-voice-text' ? 'audio-tools-upload-watermark-voice-disclosure audio-tools-upload-error' : 'audio-tools-upload-watermark-voice-disclosure'} aria-errormessage={this.state.validationTarget === 'audio-tools-upload-watermark-voice-text' ? 'audio-tools-upload-error' : undefined} aria-invalid={this.state.validationTarget === 'audio-tools-upload-watermark-voice-text' ? 'true' : undefined} />
                        <p id='audio-tools-upload-watermark-voice-disclosure' className='text-size-small text-color-secondary'>{voiceGeneration.disclosure}</p>
                      </div>
                    </>
                  )}
                  {(watermarkVoiceSource === 'custom' || voiceSourceOptions.length === 0) && (
                    <div className='input file optional'>
                      <label htmlFor='audio-tools-upload-watermark-voice'>{watermarkVoiceLabel}</label>
                      <input id='audio-tools-upload-watermark-voice' type='file' accept={watermarkVoiceAcceptedFormats.join(',')} onChange={this.handleWatermarkVoiceChange} disabled={busy} aria-describedby={this.state.validationTarget === 'audio-tools-upload-watermark-voice' ? 'audio-tools-upload-watermark-voice-hint audio-tools-upload-error' : 'audio-tools-upload-watermark-voice-hint'} aria-errormessage={this.state.validationTarget === 'audio-tools-upload-watermark-voice' ? 'audio-tools-upload-error' : undefined} aria-invalid={this.state.validationTarget === 'audio-tools-upload-watermark-voice' ? 'true' : undefined} />
                      <p id='audio-tools-upload-watermark-voice-hint' className='text-size-small text-color-secondary'>{this.copyValue('watermarkVoiceHint', 'A short audio file with the spoken watermark. It is inspected, normalized, and stored only temporarily.')} {customVoice.maxFileSizeBytes && this.copyValue('watermarkVoiceFileSize', 'Maximum voice file size: %{size} MB').replace('%{size}', Math.round(customVoice.maxFileSizeBytes / (1024 * 1024)))} {customVoice.maxDurationSeconds && this.copyValue('watermarkVoiceDuration', 'Maximum voice duration: %{duration} seconds').replace('%{duration}', customVoice.maxDurationSeconds)}</p>
                    </div>
                  )}
                </details>
              </>
            )}
          </div>
          </div>
          <div className='panel__footer'>
          <div className='form-actions'>
            <button type='submit' className='button' disabled={busy || !this.state.toolKey}>{uploading ? copy.uploading : processing ? processingCopy : copy.upload}</button>
          </div>
          {uploading && (
            <div className='audio-tools-upload__progress panel panel--attention panel--compact' role='status' aria-live='polite'>
              <label htmlFor='audio-tools-upload-progress'>{copy.progress}</label>
              <progress id='audio-tools-upload-progress' max='100' value={this.state.progress}>{this.state.progress}%</progress>
              <span>{this.state.progress}%</span>
            </div>
          )}
          {processing && (
            <div className='audio-tools-upload__processing panel panel--attention panel--compact' role='status' aria-live='polite'>
              <span className='audio-tools-upload__spinner' aria-hidden='true' />
              <span className='audio-tools-upload__processing-copy'>
                <strong>{processingCopy}</strong>
                <span>{this.copyValue('processingHint', 'You can leave this page open. We check the status automatically.')}</span>
              </span>
            </div>
          )}
          {checkoutRequired && (
            <div className='audio-tools-upload__checkout panel panel--attention panel--compact' role='status' aria-live='polite'>
              <p>{this.copyValue('checkoutRequired', 'This premium workflow requires payment before processing.')}</p>
              {this.state.job && this.state.job.checkoutUrl && (
                <button type='button' className='button' onClick={this.handleCheckout} disabled={this.state.checkoutLoading}>
                  {this.state.checkoutLoading ? this.copyValue('checkoutLoading', 'Preparing payment …') : this.copyValue('checkout', 'Pay and process now')}
                </button>
              )}
            </div>
          )}
          {this.state.error && <p id='audio-tools-upload-error' className='audio-tools-upload__error panel panel--attention panel--compact' role='alert' tabIndex='-1'>{this.state.error}</p>}
          {this.state.status === 'success' && (
            <div className='audio-tools-upload__result panel panel--success panel--compact' role='status' aria-live='polite'>
              <p>{this.state.toolKey === 'loudness_check' ? this.copyValue('analysisReady', 'The loudness analysis is ready.') : this.isAudioQc() ? this.copyValue('audioQcReady', 'The technical audio QC report is ready.') : this.state.toolKey === 'loudness_normalizer' ? this.copyValue('normalizationReady', 'Your normalized audio is ready.') : this.isPodcastReady() ? this.copyValue('podcastReadyReady', 'Your podcast-ready audio is ready.') : this.copyValue('resultReady', copy.success || 'Your audio file is ready.')}</p>
              {this.state.job && this.outputMetadataRows(this.state.job.outputMetadata).length > 0 && (
                <div className='audio-tools-upload__metadata'>
                  <h3>{this.copyValue('outputMetadataLabel', 'Technical output data')}</h3>
                  <dl>
                    {this.outputMetadataRows(this.state.job.outputMetadata).map(([label, value]) => <React.Fragment key={label}><dt>{label}</dt><dd>{value}</dd></React.Fragment>)}
                  </dl>
                </div>
              )}
              {this.state.job && this.state.job.downloadUrl && <a className='button' href={this.state.job.downloadUrl}>{this.copyValue('download', 'Download result')}</a>}
            </div>
          )}
          </div>
        </div>
      </form>
    );
  }
}

AudioToolUpload.defaultProps = {
  toolOptions: [],
  hideToolSelector: false,
  acceptedFormats: [],
  convertClean: {
    outputFormats: [{ key: 'mp3', label: 'MP3' }, { key: 'wav', label: 'WAV' }],
    metadataModes: [{ key: 'remove', label: 'Remove metadata' }, { key: 'keep', label: 'Keep metadata' }]
  },
  phoneSystemReady: {
    presets: [{ key: 'pcm_mono_wav', label: 'Standard announcement and hold music (compatible WAV)' }]
  },
  loudnessNormalizer: {
    presets: [{ key: 'podcast_speech', label: 'Podcast & speech' }]
  },
  voiceoverMusic: {
    levels: [
      { key: 'subtle', label: 'Voice-forward' },
      { key: 'normal', label: 'Balanced mix' },
      { key: 'strong', label: 'Music-forward' }
    ],
    duckingLevels: [
      { key: 'light', label: 'Gentle' },
      { key: 'balanced', label: 'Balanced' },
      { key: 'strong', label: 'Pronounced' }
    ],
    tracks: []
  },
  aiVoiceover: {
    sources: [{ key: 'uploaded', label: 'Upload a voice recording' }],
    languages: [],
    voices: [],
    maxTextLength: 5000,
    provider: 'ElevenLabs',
    disclosure: 'Your text is sent to ElevenLabs for synthetic voice generation.',
    consentLabel: 'I may submit this text and use the generated voice.',
    consentHint: 'Review the intended use and the provider terms before submitting.'
  },
  watermarkedAudioPreview: {
    previewDurations: [
      { key: 'full_track', label: 'Full track' },
      { key: '60', label: '60 seconds' },
      { key: '90', label: '90 seconds' },
      { key: '120', label: '120 seconds' }
    ],
    watermarkPositions: [
      { key: 'beginning_end', label: 'Beginning and end' },
      { key: 'repeated', label: 'Repeated' }
    ],
    watermarkLevels: [
      { key: 'subtle', label: 'Subtle' },
      { key: 'normal', label: 'Normal' },
      { key: 'strong', label: 'Strong' }
    ],
    forensicWatermark: { available: false, label: 'Enable robust watermarking', hint: 'Optional internal identification layer; not a guarantee against removal.' },
    recipientMaxLength: 200,
    recipientHint: 'Optional for your internal preview reference. This value is not written into the audio file.',
    voiceGeneration: {
      available: false,
      sources: [],
      languages: [],
      voices: [],
      maxTextLength: 240,
      disclosure: 'The text is sent to ElevenLabs to generate the voice. The generated audio file is stored only temporarily.'
    },
    customVoice: {
      acceptedFormats: [],
      maxFileSizeBytes: 20 * 1024 * 1024,
      maxDurationSeconds: 30
    }
  },
  copy: {
    toolLabel: 'Audio task',
    fileLabel: 'Audio file',
    chooseFile: 'Choose an audio file',
    dropzoneTitle: 'Drop your audio file here',
    dropzoneHint: 'or choose a file – the file is checked securely on the server.',
    selectedFileLabel: 'Selected file',
    configurationLabel: 'Set the output',
    advancedOptionsLabel: 'Advanced settings',
    advancedOptionsHint: 'Optional: open this only when you want more control over the result.',
    mixOptionsLabel: 'Fine-tune the mix',
    watermarkOptionsLabel: 'Adjust the watermark',
    aiVoiceOptionsLabel: 'Configure the voice',
    trackSelectionLabel: 'Choose music',
    selectTrack: 'Select this track',
    selectedTrack: 'Selected',
    trackPreviewLabel: 'Music preview for %{title}',
    noTrackPreview: 'No preview is currently available for this track.',
    upload: 'Upload file securely',
    uploading: 'Uploading file …',
    success: 'Upload accepted.',
    allowedFormats: '',
    noFile: 'Please choose an audio file first.',
    genericError: 'The upload could not be completed.',
    fileSizeExceeded: 'The uploaded file is too large.',
    outputFormatLabel: 'Output format',
    metadataLabel: 'Metadata',
    phoneSystemPresetLabel: 'Phone system format',
    loudnessPresetLabel: 'Intended use',
    musicTrackLabel: 'Music track',
    musicLevelLabel: 'Music level',
    duckingLevelLabel: 'Automatic ducking',
    musicTrackRequired: 'Please choose a music track.',
    aiVoiceSourceLabel: 'Voice source',
    aiVoiceTextLabel: 'Voiceover text',
    aiVoiceLanguageLabel: 'Voice language',
    aiVoiceKeyLabel: 'Voice',
    aiVoiceConsentLabel: 'I may submit this text and use the generated voice.',
    aiVoiceTextRequired: 'Please enter the voiceover text.',
    aiVoiceUnavailable: 'The generated AI voice is not available.',
    aiVoiceConsentRequired: 'Please confirm that you may submit this text and use the generated voice.',
    previewDurationLabel: 'Preview length',
    watermarkPositionLabel: 'Watermark position',
    watermarkLevelLabel: 'Watermark level',
    forensicWatermarkLabel: 'Robust watermarking',
    forensicWatermarkHint: 'Optional internal identification layer; not a guarantee against removal.',
    recipientReferenceLabel: 'Recipient (optional)',
    recipientReferencePlaceholder: 'e.g. Example Agency',
    watermarkVoiceSourceLabel: 'Watermark voice',
    watermarkVoiceTextLabel: 'Watermark text',
    watermarkVoiceLanguageLabel: 'Watermark language',
    watermarkVoiceKeyLabel: 'Voice',
    watermarkVoiceLabel: 'Custom watermark voice (optional)',
    watermarkVoiceHint: 'A short audio file with the spoken watermark. It is inspected, normalized, and stored only temporarily.',
    watermarkVoiceFileSize: 'Maximum voice file size: %{size} MB',
    watermarkVoiceDuration: 'Maximum voice duration: %{duration} seconds',
    watermarkVoiceFileSizeExceeded: 'The watermark voice file is too large.',
    watermarkVoiceTextRequired: 'Please enter the watermark text.',
    watermarkVoiceUnavailable: 'The generated watermark voice is not available.',
    watermarkVoiceRequired: 'Please choose a custom watermark voice.',
    outputMetadataLabel: 'Technical output data',
    outputFormatMetadataLabel: 'Format',
    outputCodecMetadataLabel: 'Codec',
    outputSampleRateMetadataLabel: 'Sample rate',
    outputChannelsMetadataLabel: 'Channels',
    outputBitsPerSampleMetadataLabel: 'Bit depth',
    outputIntegratedLufsLabel: 'Integrated loudness',
    outputLoudnessRangeLabel: 'Loudness range',
    outputPeakDbfsLabel: 'Peak',
    outputTruePeakDbfsLabel: 'True peak',
    outputDurationLabel: 'Duration',
    outputPresetLabel: 'Preset',
    outputTargetLufsLabel: 'Target loudness',
    outputTargetTruePeakLabel: 'Target true peak',
    analysisReady: 'The loudness analysis is ready.',
    audioQcReady: 'The technical audio QC report is ready.',
    audioQcStatusLabel: 'Overall status',
    audioQcOk: 'No attention needed',
    audioQcAttention: 'Needs attention',
    audioQcUnknown: 'Not available',
    audioQcClippingLabel: 'Clipping',
    audioQcLoudnessLabel: 'Loudness',
    audioQcChannelsLabel: 'Channels',
    audioQcCodecLabel: 'Codec',
    audioQcSampleRateLabel: 'Sample rate',
    audioQcLongSilenceLabel: 'Long silence',
    audioQcMetadataLabel: 'Metadata',
    audioQcMeasured: 'Measured',
    audioQcNoMetadata: 'No metadata detected',
    audioQcMetadataFields: '%{count} fields detected',
    normalizationReady: 'Your normalized audio is ready.',
    podcastReadyReady: 'Your podcast-ready audio is ready.',
    podcastReadyTargetLufsLabel: 'Target loudness',
    podcastReadyTargetTruePeakLabel: 'Target true peak',
    processing: 'Processing audio file …',
    checkoutRequired: 'This premium workflow requires payment before processing.',
    checkout: 'Pay and process now',
    checkoutLoading: 'Preparing payment …',
    checkoutError: 'The payment could not be started. Please try again.',
    download: 'Download result',
    resultReady: 'Your audio file is ready.',
    processingError: 'The audio file could not be processed. Please try again.',
    progress: 'Upload progress'
  }
};

document.querySelectorAll('[data-react-component=AudioToolUpload]').forEach((element) => {
  try {
    ReactDOM.render(<AudioToolUpload {...parseReactProps(element.dataset.reactProps)} />, element);
  } catch (error) {
    console.error('Failed to mount AudioToolUpload', error);
  }
});

export default AudioToolUpload;
